export default {
	title: 'Partes interesadas',
	context_best: 'Favorable',
	context_worse: 'Hostil',
	zones: {
		positive: 'Favorable',
		positive_line2: 'Zona',
		neutral: 'Neutral',
		negative: 'Hostil',
		negative_line2: 'Zona',
		point_of_view_line1: 'Punto',
		point_of_view_line2: 'de',
		point_of_view_line3: 'vista'
	},
	tabs: {
		general: {
			title: 'General'
		},
		links: {
			title: 'Enlaces'
		},
		comments: {
			title: 'Historial'
		},
		filters: {
			title: 'Filtros de vista'
		},
		export: {
			title: 'Exportar',
			image: 'Exportar radar como imagen'
		},
		risks: {
			title: 'Riesgos'
		},
		bot: {
			title: 'IA'
		},
		tags: {
			title: 'Etiquetas',
			assigned: 'Etiquetas asignadas',
			unassigned: 'Etiquetas no asignadas'
		},
		disabled: {
			title: 'Desactivados'
		}
	},
	summary: {
		key_drivers: 'Factores clave',
		scenario_score: 'Puntuación del escenario',
		max_value: 'máx {{value}}',
		legend: {
			current: 'Actual',
			scenario: 'Escenario'
		}
	},
	all_tags: 'Filtro de etiquetas',
	links: 'Mostrar todos los enlaces',
	no_tag: 'Sin etiqueta',

	all_icons: 'Filtro de iconos',
	no_icon: 'Sin icono',

	all_stakes: 'Filtro de intereses',
	all_constraints: 'Filtro de indicadores',
	all_risks: 'Filtro de riesgos',
	all_opportunities: 'Filtro de aperturas',

	alignment: {
		title_1: 'Parte interesada',
		title_2: 'alineación'
	},
	onboarding: {
		title: 'Revisar las partes interesadas',
		description:
			'Los actores que pesan sobre su tema están posicionados en el radar según su influencia y su postura. Verifique la alineación y ajuste si su lectura difiere.'
	}
};
